(function () {
  if (window.__imageBoxTabLoaded) return;
  window.__imageBoxTabLoaded = true;

  var WRAPPER_SELECTOR = '[data-image-tabs]';
  var NAV_SELECTOR = '[data-image-tab-nav]';
  var PANELS_SELECTOR = '[data-image-tab-panels]';
  var PANEL_SELECTOR = '.bls__cls-tab';
  var BUTTON_SELECTOR = '.image-tab__item';
  var ITEM_SELECTOR = '[data-image-tab-item]';
  var LOAD_MORE_WRAPPER_SELECTOR = '[data-load-more-wrapper]';
  var LOAD_MORE_BUTTON_SELECTOR = '[data-load-more-button]';
  var TAB_BUTTON_TEMPLATE_SELECTOR = '[data-image-tab-button-template]';
  var TAB_BUTTON_TEXT_SELECTOR = '[data-image-tab-button-text]';

  var MOBILE_MEDIA_QUERY = '(max-width: 575.98px)';
  var TAB_DESIGNS = ['horizontal', 'underline', 'select'];

  function toNumber(value, fallback) {
    var number = parseInt(value, 10);
    return isNaN(number) ? fallback : number;
  }

  function isTrue(value) {
    return value === true || value === 'true';
  }

  function safeId(value) {
    return String(value || '')
      .trim()
      .replace(/[^a-zA-Z0-9\-_:.]/g, '-');
  }

  function normalizeTabDesign(value) {
    if (TAB_DESIGNS.indexOf(value) !== -1) {
      return value;
    }

    return 'underline';
  }

  function isMobileViewport() {
    return window.matchMedia && window.matchMedia(MOBILE_MEDIA_QUERY).matches;
  }

  function getCurrentLimit(wrapper) {
    var desktopLimit = toNumber(wrapper.dataset.itemsToShow, 6);
    var mobileLimit = toNumber(wrapper.dataset.itemsToShowMobile, desktopLimit);

    return isMobileViewport() ? mobileLimit : desktopLimit;
  }

  function getSettings(wrapper) {
    return {
      limit: getCurrentLimit(wrapper),
      loadMoreEnable: isTrue(wrapper.dataset.loadMoreEnable),
      loadMoreLabel: wrapper.dataset.loadMoreLabel || 'Load more',
      buttonType: wrapper.dataset.buttonType || 'primary',
      tabDesign: normalizeTabDesign(wrapper.dataset.tabDesign || 'underline')
    };
  }

  function getTabTitle(panel, index) {
    var sourceTitle = panel.querySelector('[data-tab-title-source]');

    var titleFromSource =
      sourceTitle && sourceTitle.textContent
        ? sourceTitle.textContent.trim()
        : '';

    var titleFromData =
      panel.dataset.tabTitle
        ? panel.dataset.tabTitle.trim()
        : '';

    return titleFromSource || titleFromData || 'Tab ' + (index + 1);
  }

  function syncTabDesignClass(wrapper, nav) {
    var settings = getSettings(wrapper);
    var tabDesign = settings.tabDesign;

    TAB_DESIGNS.forEach(function (design) {
      nav.classList.remove('image-tab--' + design);
      wrapper.classList.remove('bls__collection-tab--' + design);
    });

    nav.classList.add('image-tab--' + tabDesign);
    wrapper.classList.add('bls__collection-tab--' + tabDesign);
  }

  function clearGeneratedTabButtons(nav) {
    Array.prototype.slice
      .call(nav.querySelectorAll(BUTTON_SELECTOR))
      .forEach(function (button) {
        button.remove();
      });
  }

  function createImageTabButton(nav, panelId, title) {
    var template = nav.querySelector(TAB_BUTTON_TEMPLATE_SELECTOR);
    var button = null;

    if (template && template.content && template.content.firstElementChild) {
      button = template.content.firstElementChild.cloneNode(true);
    }

    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'image-tab__item';

      var inner = document.createElement('span');
      inner.className = 'image-tab__item-inner';

      var text = document.createElement('span');
      text.className = 'image-tab__item-text';
      text.setAttribute('data-image-tab-button-text', '');

      inner.appendChild(text);
      button.appendChild(inner);
    }

    var isNativeButton = button.tagName.toLowerCase() === 'button';

    if (isNativeButton) {
      button.type = 'button';
    } else {
      button.setAttribute('role', 'tab');
      button.setAttribute('tabindex', '-1');
    }

    button.classList.add('image-tab__item');
    button.dataset.tabTarget = panelId;
    button.dataset.id = panelId;
    button.id = 'image-tab-button-' + safeId(panelId);
    button.setAttribute('role', 'tab');
    button.setAttribute('aria-controls', panelId);
    button.setAttribute('aria-selected', 'false');
    button.setAttribute('aria-label', title);

    var textTarget = button.querySelector(TAB_BUTTON_TEXT_SELECTOR);

    if (textTarget) {
      textTarget.textContent = title;
    } else {
      button.textContent = title;
    }

    return button;
  }

  function getPanelItems(panel) {
    return Array.prototype.slice
      .call(panel.querySelectorAll(ITEM_SELECTOR))
      .filter(function (item) {
        return item.closest(PANEL_SELECTOR) === panel;
      });
  }

  function getActivePanel(wrapper) {
    return wrapper.querySelector(PANEL_SELECTOR + '.active');
  }

  function getLoadMoreWrapper(wrapper) {
    return wrapper.querySelector(LOAD_MORE_WRAPPER_SELECTOR);
  }

  function getLoadMoreButton(wrapper) {
    return wrapper.querySelector(LOAD_MORE_BUTTON_SELECTOR);
  }

  function hasHiddenItems(wrapper, panel) {
    if (!wrapper || !panel) return false;

    var settings = getSettings(wrapper);
    var items = getPanelItems(panel);

    if (!items.length) return false;
    if (settings.limit < 1) return false;
    if (panel.dataset.imageTabExpanded === 'true') return false;

    return items.length > settings.limit;
  }

  function applyLimitToPanel(wrapper, panel) {
    if (!wrapper || !panel) return;

    var settings = getSettings(wrapper);
    var items = getPanelItems(panel);

    if (!items.length) return;

    var stateKey = String(settings.limit);

    if (panel.dataset.imageTabLimitKey !== stateKey) {
      delete panel.dataset.imageTabExpanded;
      panel.dataset.imageTabLimitKey = stateKey;
    }

    var isExpanded = panel.dataset.imageTabExpanded === 'true';
    var shouldLimit =
      settings.limit > 0 &&
      items.length > settings.limit &&
      !isExpanded;

    items.forEach(function (item, index) {
      var shouldHide = shouldLimit && index >= settings.limit;

      item.hidden = shouldHide;
      item.classList.toggle('image-tab__hidden-item', shouldHide);
    });
  }

  function applyLimitToAllPanels(wrapper) {
    if (!wrapper) return;

    Array.prototype.slice
      .call(wrapper.querySelectorAll(PANEL_SELECTOR))
      .forEach(function (panel) {
        applyLimitToPanel(wrapper, panel);
      });
  }

  function syncLoadMoreButton(wrapper) {
    if (!wrapper) return;

    var settings = getSettings(wrapper);
    var loadMoreWrapper = getLoadMoreWrapper(wrapper);
    var loadMoreButton = getLoadMoreButton(wrapper);
    var activePanel = getActivePanel(wrapper);

    if (!loadMoreWrapper || !loadMoreButton) return;

    if (!settings.loadMoreEnable || !activePanel) {
      loadMoreWrapper.hidden = true;
      return;
    }

    applyLimitToPanel(wrapper, activePanel);

    var shouldShowButton = hasHiddenItems(wrapper, activePanel);

    loadMoreWrapper.hidden = !shouldShowButton;

    if (shouldShowButton) {
      var loadMoreText = loadMoreButton.querySelector('[data-load-more-text]');

      if (loadMoreText) {
        loadMoreText.textContent = settings.loadMoreLabel;
      } else {
        loadMoreButton.textContent = settings.loadMoreLabel;
      }

      loadMoreButton.setAttribute('aria-controls', activePanel.id);
    }
  }

  function activateImageBoxTab(wrapper, targetId) {
    if (!wrapper || !targetId) return;

    Array.prototype.slice
      .call(wrapper.querySelectorAll(BUTTON_SELECTOR))
      .forEach(function (button) {
        var isActive = button.dataset.tabTarget === targetId;

        button.classList.toggle('active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        button.setAttribute('tabindex', isActive ? '0' : '-1');
      });

    Array.prototype.slice
      .call(wrapper.querySelectorAll(PANEL_SELECTOR))
      .forEach(function (panel) {
        panel.classList.toggle('active', panel.id === targetId);
      });

    syncLoadMoreButton(wrapper);
  }

  function buildImageBoxTabs(wrapper) {
    if (!wrapper) return;
    if (wrapper.dataset.imageTabsBuilding === 'true') return;

    wrapper.dataset.imageTabsBuilding = 'true';

    try {
      var nav = wrapper.querySelector(NAV_SELECTOR);
      var panelsContainer = wrapper.querySelector(PANELS_SELECTOR);

      var panels = panelsContainer
        ? Array.prototype.slice.call(panelsContainer.querySelectorAll(PANEL_SELECTOR))
        : [];

      if (!nav || !panels.length) return;

      var activeButton = nav.querySelector(BUTTON_SELECTOR + '.active');

      var activePanel = panels.find(function (panel) {
        return panel.classList.contains('active');
      });

      var currentActiveId =
        activeButton && activeButton.dataset.tabTarget
          ? activeButton.dataset.tabTarget
          : activePanel
            ? activePanel.id
            : panels[0].id;

      clearGeneratedTabButtons(nav);
      syncTabDesignClass(wrapper, nav);

      panels.forEach(function (panel, index) {
        var panelId = panel.id;

        if (!panelId) {
          var sectionEl = wrapper.closest ? wrapper.closest('section') : null;
          var sectionId =
            wrapper.dataset.id ||
            (sectionEl && sectionEl.id) ||
            'image-box-tab';

          panelId = 'image-tab-panel-' + safeId(sectionId) + '-' + index;
          panel.id = panelId;
        }

        var title = getTabTitle(panel, index);
        var button = createImageTabButton(nav, panelId, title);

        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', button.id);

        nav.appendChild(button);
      });

      var activeId = panels.some(function (panel) {
        return panel.id === currentActiveId;
      })
        ? currentActiveId
        : panels[0].id;

      applyLimitToAllPanels(wrapper);
      activateImageBoxTab(wrapper, activeId);
    } finally {
      delete wrapper.dataset.imageTabsBuilding;
    }
  }

  function initImageBoxTab(wrapper) {
    if (!wrapper) return;

    buildImageBoxTabs(wrapper);

    if (wrapper.dataset.imageTabsReady === 'true') return;
    wrapper.dataset.imageTabsReady = 'true';

    var panelsContainer = wrapper.querySelector(PANELS_SELECTOR);

    if (panelsContainer && window.MutationObserver) {
      var timer;

      var observer = new MutationObserver(function () {
        if (wrapper.dataset.imageTabsBuilding === 'true') return;

        clearTimeout(timer);

        timer = setTimeout(function () {
          buildImageBoxTabs(wrapper);
        }, 50);
      });

      observer.observe(panelsContainer, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }

  function initAllImageBoxTabs(root) {
    var scope = root || document;

    if (scope.matches && scope.matches(WRAPPER_SELECTOR)) {
      initImageBoxTab(scope);
      return;
    }

    Array.prototype.slice
      .call(scope.querySelectorAll(WRAPPER_SELECTOR))
      .forEach(function (wrapper) {
        initImageBoxTab(wrapper);
      });
  }

  function refreshImageBoxTabLimits(root) {
    var scope = root || document;
    var wrappers = [];

    if (scope.matches && scope.matches(WRAPPER_SELECTOR)) {
      wrappers = [scope];
    } else {
      wrappers = Array.prototype.slice.call(scope.querySelectorAll(WRAPPER_SELECTOR));
    }

    wrappers.forEach(function (wrapper) {
      applyLimitToAllPanels(wrapper);
      syncLoadMoreButton(wrapper);
    });
  }

  document.addEventListener('click', function (event) {
    var loadMoreButton = event.target.closest(LOAD_MORE_BUTTON_SELECTOR);

    if (loadMoreButton) {
      var wrapper = loadMoreButton.closest(WRAPPER_SELECTOR);
      var activePanel = wrapper ? getActivePanel(wrapper) : null;

      if (!wrapper || !activePanel) return;

      activePanel.dataset.imageTabExpanded = 'true';

      applyLimitToPanel(wrapper, activePanel);
      syncLoadMoreButton(wrapper);

      return;
    }

    var tabButton = event.target.closest(BUTTON_SELECTOR);

    if (!tabButton) return;

    var tabWrapper = tabButton.closest(WRAPPER_SELECTOR);

    if (!tabWrapper) return;

    activateImageBoxTab(tabWrapper, tabButton.dataset.tabTarget);
  });

  document.addEventListener('keydown', function (event) {
    var clickable = event.target.closest(
      BUTTON_SELECTOR + ', ' + LOAD_MORE_BUTTON_SELECTOR
    );

    if (!clickable) return;

    if (event.key !== 'Enter' && event.key !== ' ') return;

    event.preventDefault();
    clickable.click();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAllImageBoxTabs(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var blockId = event.detail && event.detail.blockId;
    var selectedBlock = blockId ? document.getElementById(blockId) : null;

    if (!selectedBlock && event.target instanceof Element) {
      selectedBlock = event.target;
    }

    if (!selectedBlock) return;

    var panel = selectedBlock.closest(PANEL_SELECTOR);

    if (!panel) return;

    var wrapper = panel.closest(WRAPPER_SELECTOR);

    if (!wrapper) return;

    buildImageBoxTabs(wrapper);
    activateImageBoxTab(wrapper, panel.id);
  });

  var resizeTimer;

  function handleResponsiveLimitChange() {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(function () {
      refreshImageBoxTabLimits(document);
    }, 150);
  }

  window.addEventListener('resize', handleResponsiveLimitChange);

  if (window.matchMedia) {
    var mobileMediaQuery = window.matchMedia(MOBILE_MEDIA_QUERY);

    if (mobileMediaQuery.addEventListener) {
      mobileMediaQuery.addEventListener('change', function () {
        refreshImageBoxTabLimits(document);
      });
    } else if (mobileMediaQuery.addListener) {
      mobileMediaQuery.addListener(function () {
        refreshImageBoxTabLimits(document);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllImageBoxTabs(document);
    });
  } else {
    initAllImageBoxTabs(document);
  }
})();